module.exports = __webpack_public_path__ + "OpenSans-BoldItalic.127782cd1371d1dad12a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-BoldItalic.woff
// module id = ../../../../../src/assets/customfonts/OpenSans-BoldItalic.woff
// module chunks = styles